import {Component, OnInit} from '@angular/core';
import {GlobalContributorsSnippetManagementComponent} from "@/_components/text-snippet-management/global-contributors-snippet-management/global-contributors-snippet-management.component";

@Component({
  selector: 'app-wwtps-contributors',
  templateUrl: './global-contributors-snippet-management.component.html',
  styleUrls: ['./global-contributors-snippet-management.component.css']
})
export class WwtpsContributorsComponent extends GlobalContributorsSnippetManagementComponent{
    ContributorCategory = "wwtps";

    constructor() {
        super();
    }


    DeleteSnippetFromServer($event){
        this.SetLoadingState();
        this.ProcessServerRequest(this.snippetService.DeleteWWTPSContributorSnippet($event)).then(()=>{
            super.SetStatusMessage("Contributors deleted successfully");
        }).catch(error=>{
            super.AfterErrorReceived(error, "Error deleting snippet.");
        }).finally(()=>{
            super.SetFinishedLoadingState();
        });
    }
}
